import { render } from "./ActivitiesOverlay.vue?vue&type=template&id=1d186cb4&scoped=true"
import script from "./ActivitiesOverlay.vue?vue&type=script&lang=js"
export * from "./ActivitiesOverlay.vue?vue&type=script&lang=js"

import "./ActivitiesOverlay.vue?vue&type=style&index=0&id=1d186cb4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d186cb4"]])

export default __exports__